import { useContext, useState } from 'react';

import { useAppSelector, useAppDispatch } from 'hooks';

import {
  Text,
  Box,
  Flex,
  Button,
  Collapse,
  Icon,
  Alert,
} from '@chakra-ui/react';

import { DeleteIcon, ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

import Card from 'components/card/Card';

import FormInput from 'components/fields/auto/FormInput';
import DateInput from 'components/fields/auto/DateInput';
import Message from 'components/fields/auto/Message';

import getDateFromString from 'helpers/getDateFromString';

import getValidationMessage from 'helpers/getValidationMessage';

import {
  addConviction,
  changeConvictions,
  removeConviction,
} from 'reducers/autoPersonalFormReducer';

import useIsBinderDisabled from 'views/auto_form/hooks/useIsBinderDisabled';

import getDateString from 'helpers/getDateString';

import { SECTIONS } from 'views/auto_form/constants';

import { ApplicationFormContext } from 'contexts/ApplicationFormContext';

const Convictions = () => {
  const { validations } = useContext(ApplicationFormContext) as {
    validations: Validation[];
  };
  const dispatch = useAppDispatch();

  const validation033 = getValidationMessage(validations, '033');

  const [isCollapsed, setIsCollapsed] = useState(true);

  const convictions = useAppSelector(
    (state) => state.autoPersonalForm.data.convictions,
  );

  const isDisabled = useIsBinderDisabled(true);

  const onConvictionChange = (event: any, index: number) => {
    const { name, value, checked, type } = event.target;
    const payload = type === 'checkbox' ? checked : value;

    dispatch(changeConvictions({ name, index, value: payload }));
  };

  const onDateChange = (date: Date, name: string, index: number) => {
    dispatch(changeConvictions({ name, index, value: getDateString(date) }));
  };

  const onAddNewConviction = () => {
    dispatch(addConviction());
  };

  const onRemoveConviction = (_: any, index: number) => {
    dispatch(removeConviction(index));
  };

  return (
    <Card mb="20px" id="sectionConvictions">
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontWeight="bold" fontSize="xl">
          Convictions Summary{' '}
          <Text textColor="red" display="inline">
            (dev mode)
          </Text>
        </Text>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsCollapsed(!isCollapsed)}
          rightIcon={
            <Icon as={isCollapsed ? ChevronDownIcon : ChevronUpIcon} />
          }
        >
          {isCollapsed ? 'Expand' : 'Collapse'}
        </Button>
      </Flex>

      <Collapse in={!isCollapsed} animateOpacity>
        <Text fontSize="xs" mt="20px">
          Give details of all convictions of the applicant and any listed driver
          arising from the operation of any automobile in the last 3 years.
        </Text>

        {validation033 && (
          <>
            <Message
              validationId="033"
              section={SECTIONS.CONVICTIONS}
              hideRemarks
            />
            <Alert status="info" mt="10px">
              Only the below Convictions will appear on Application
            </Alert>
          </>
        )}

        {convictions.map((conviction, index) => {
          return (
            <Flex gap="20px" mt="20px" key={index}>
              <Box w="10%">
                <FormInput
                  section={SECTIONS.CONVICTIONS}
                  label="Driver"
                  name="driver_nr"
                  value={conviction.driver_nr}
                  onChange={(e) => onConvictionChange(e, index)}
                  disabled
                />
              </Box>

              <Box w="20%">
                <DateInput
                  section={SECTIONS.CONVICTIONS}
                  label="Date"
                  date={getDateFromString(conviction.date)}
                  onChange={(date: Date) => onDateChange(date, 'date', index)}
                  disabled
                />
              </Box>

              <FormInput
                section={SECTIONS.CONVICTIONS}
                label="Details"
                name="details"
                value={conviction.details}
                onChange={(e) => onConvictionChange(e, index)}
                disabled
              />

              {!isDisabled && (
                <Button mt="30px" onClick={(e) => onRemoveConviction(e, index)}>
                  <DeleteIcon />
                </Button>
              )}
            </Flex>
          );
        })}

        {!isDisabled && (
          <Box mt="20px">
            <Button variant="brand" onClick={onAddNewConviction}>
              Add new
            </Button>
          </Box>
        )}
      </Collapse>
    </Card>
  );
};

export default Convictions;
